<ng-template #iconRef>
	<svg fill="none" height="70" viewBox="0 0 70 70" width="70" xmlns="http://www.w3.org/2000/svg">
		<circle cx="35" cy="35" fill="#0361F0" opacity="0.1" r="35"/>
		<path
			d="M35 55C23.9543 55 15 46.0457 15 35C15 23.9543 23.9543 15 35 15C46.0457 15 55 23.9543 55 35C54.9879 46.0407 46.0407 54.9879 35 55ZM30.98 32.98V37H32.98V45H39.02V41H37L37.02 32.982L30.98 32.98ZM32.98 25V29.038H37.02V25H32.98Z"
			fill="#0361F0"/>
	</svg>
</ng-template>
<app-kamona-dialog [icon]="iconRef">
	<div class="password-recovery-success">
		<div class="title">
			You’ve Got Mail
		</div>
		<div class="note">
			An email was sent to you,
			Please follow the link in the email
			we sent you to reset your password
		</div>
		<div class="m-t-64">
			<div class="kamona-button-session">
				<app-kamona-custom-button (submitForm)="closeModal()" [isBlock]="true"
										  text="Continue to Login">
				</app-kamona-custom-button>
			</div>
			<div class="m-t-33">
				<div (click)="closeModal()" class="dismiss-btn">
					Dismiss
				</div>
			</div>
		</div>
	</div>
</app-kamona-dialog>
